import LotShortDescription from './lot-short-description';
export default LotShortDescription;